<script>
  /* global Global */
  import SmallTitle from '../common/SmallTitle.svelte';
  import GameLegend from './schedule-and-results/GameLegend.svelte';
  import Game from './schedule-and-results/Game.svelte';
  import Common from '../js/common.js';

  export let games;
  export let year;
  export let narrow = false;
  export let detail = true;
  export let scroll = undefined;
  export let lang = undefined;
  export let user;

  const scheduleDateElements = {};

  let dates = [];

  $: dates = Common.unique(games.map(game => game.date));

  const datesWithAsterisk = Global.scheduleAndResults.datesWithAsterisk;
  const firstWithDetail = Global.scheduleAndResults.firstWithDetail;

  scroll = () => {
    scheduleDateElements[Object.keys(scheduleDateElements).reduce((a, b) =>
      Math.abs(parseInt(a) - parseInt(Common.getDbDate())) < Math.abs(parseInt(b) - parseInt(Common.getDbDate())) ? a : b,
    )].scrollIntoView({ behavior: 'smooth' });
  };
</script>

<div class='schedule' class:schedule-narrow={narrow}>
  {#each dates as date}
    <div class='schedule-date' bind:this={scheduleDateElements[Common.formatDbDate(date)]}>
      <div class='schedule-date-small-title'>
        {#if datesWithAsterisk.includes(date)}
          <SmallTitle value={`${Common.getDayOfWeek(date)[lang]}*`} append={date} appendShort={Common.formatDateShort(date)}/>
        {:else}
          <SmallTitle value={`${Common.getDayOfWeek(date)[lang]}`} append={date} appendShort={Common.formatDateShort(date)}/>
        {/if}
      </div>

      <div class='schedule-date-content'>
        <div class='schedule-date-content-game-legend'>
          <GameLegend bind:lang/>
        </div>

        {#each games.filter(game => game.date === date) as game}
          <div class='schedule-date-content-game'>
            <Game value={game} bind:year detail={detail && year >= firstWithDetail} bind:lang bind:user/>
          </div>
        {/each}
      </div>
    </div>
  {/each}
</div>

<style>
  .schedule {
    display: flex;
    flex-direction: column;
    gap: 40px;
  }

  .schedule-date {
    display: flex;
    flex-direction: column;
    gap: 20px;

    scroll-margin: 100px;
  }

  .schedule-date-content {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .schedule-date-content-game-legend {
    margin-bottom: -5px;
  }
</style>
